import { Component } from "@angular/core";
import { LanguageService } from "app/core/services/language/language.service";

@Component({
  selector: "app-language-switcher",
  templateUrl: "./language-switcher.component.html"
})
export class LanguageSwitcherComponent {
  constructor(public language: LanguageService) {}

  select(code: string): void {
    this.language.use(code).subscribe();
  }
}
